import { VmessAccountActions } from "@dots-crm/contracts/client";

export const VMESS_ACCOUNT_ENDPOINTS_URLS = {
  create: "vmess-account",
  readMany: "vmess-account",
  delete: ({ vmessAccountId }: VmessAccountActions["delete"]["params"]) =>
    `vmess-account/${vmessAccountId}`,
  import: "vmess-account/import",
  importTemplate: "vmess-account/import/template",
  export: "vmess-account/export",
};

export const VMESS_ACCOUNT_TAGS = {
  vmessAccount: "vmessAccount",
};
